enum ClientWebsiteStatus
{
    None = 0,
    Disabled = 10,
    Development = 20,
    Live = 30
}

enum ClientWebsiteMapProvider
{
    None,
    GoogleMaps,
    Mapbox
}

enum ClientWebsiteGeocoderProvider
{
    None,
    GoogleMaps,
    Mapbox
}

enum ReCaptchaVersion {
    None = 0,
    V1 = 10,
    V2Checkbox = 20,
    V2Invisible = 21,
    V3 = 30
}

enum WebsiteLevel {
    Country,
    Zone,
    Franchise,
    Office,
    Profile,
    Terminal
}

interface WebsiteReCaptchaConfig {
    ReCaptchaVersion: ReCaptchaVersion;
    ReCaptchaSiteKey: string;
}

interface WebsiteAnalyticsConfig {
    PROListAnalyticsWebsiteId: string;

    GoogleAnalyticsTrackingIds: string[];
    FacebookTrackingIds: string[];
}

interface WebsiteMapProviderConfig {
    MapProvider: ClientWebsiteMapProvider;
    APIKey: string;
    Interactive: boolean;
    MapboxStyleURI: string;
}

interface WebsiteGeocoderProviderConfig {
    GeocoderProvider: ClientWebsiteGeocoderProvider;
    APIKey: string;
}

interface WebsiteConfig {
    ClientWebsiteId: string;
    Status: ClientWebsiteStatus;

    WebsiteLevel: WebsiteLevel;
    WebsiteId: string;

    ReCaptcha: WebsiteReCaptchaConfig;
    Analytics: WebsiteAnalyticsConfig;
    MapProvider: WebsiteMapProviderConfig;
    GeocoderProvider: WebsiteGeocoderProviderConfig;
}

export { ClientWebsiteStatus, ClientWebsiteMapProvider, ClientWebsiteGeocoderProvider, ReCaptchaVersion, WebsiteLevel, WebsiteReCaptchaConfig, WebsiteAnalyticsConfig, WebsiteMapProviderConfig, WebsiteGeocoderProviderConfig, WebsiteConfig }